export const ACCOUNT_LEDGERS_RESET_STATE = 'ACCOUNT_LEDGERS_RESET_STATE';
export const ACCOUNT_LEDGERS_CURRENT_ITEM = 'ACCOUNT_LEDGERS_CURRENT_ITEM';

export const ACCOUNT_LEDGERS_REQUEST_LOADING = 'ACCOUNT_LEDGERS_REQUEST_LOADING';
export const ACCOUNT_LEDGERS_REQUEST_SUCCESS = 'ACCOUNT_LEDGERS_REQUEST_SUCCESS';
export const ACCOUNT_LEDGERS_REQUEST_FAILED = 'ACCOUNT_LEDGERS_REQUEST_FAILED';

export const ACCOUNT_LEDGERS_CURRENT_ACTION = 'ACCOUNT_LEDGERS_CURRENT_ACTION';
export const ACCOUNT_LEDGERS_RESET_ACTION = 'ACCOUNT_LEDGERS_RESET_ACTION';